import { SignInPanel } from './sign-in-panel.js';
import { SettingsGear } from './settings-gear.js';
import brandLogoDark from '../assets/brand-logo-dark.png';
import brandLogoLight from '../assets/brand-logo-light.png';

/**
 * The one header, for parents, coaches and athletes alike (RE-29: every page
 * shares an identical nav structure). Moved out of AppLayout on 16 October when
 * the athlete's frame needed the same one.
 */
export function AppHeader() {
  return (
    <header className="app-header">
      {/* Matthew's logo, approved 18 October (canvas row E): one image per
          theme, cut from his logoloop.png - white lettering on dark, his navy
          on light. The one not in use is display:none, so a screen reader
          reads the heading once. */}
      <h1 className="brand">
        <img className="brand-dark" src={brandLogoDark} alt="#ihitdifferent" width={187} height={28} />
        <img className="brand-light" src={brandLogoLight} alt="#ihitdifferent" width={187} height={28} />
      </h1>
      <div className="app-header-actions">
        {/* The MPC coach's gear: all configuration goes through it (25 October). */}
        <SettingsGear />
        <SignInPanel />
      </div>
    </header>
  );
}
